// Resolves whether a per-member role dropdown in Owner Console has an
// uncommitted change vs. the persisted role. Encodes the fix for v2.1
// finding #30 (silent draft loss when navigating away without clicking Save).
// Pure helper so the visibility contract can be unit-tested without RTL.

export type OwnerConsoleMemberRole = 'viewer' | 'contributor' | 'editor' | 'admin'

export type MemberRoleDraftState = 'clean' | 'pending'

export type MemberRoleDraftInput = {
  // Currently persisted role from the server. `admin` rows are rendered as
  // read-only so the draft state cannot legitimately diverge — we still
  // collapse to `clean` if the caller passes it.
  currentRole: OwnerConsoleMemberRole | string
  // The draft value held in `memberRoleDrafts[member.id]`. May be undefined
  // when no draft has been touched yet (in which case nothing is pending).
  draftRole: OwnerConsoleMemberRole | string | undefined
}

const sanitize = (value: string | undefined | null): string =>
  typeof value === 'string' ? value.trim() : ''

export const getMemberRoleDraftState = (input: MemberRoleDraftInput): MemberRoleDraftState => {
  const current = sanitize(input.currentRole)
  const draft = sanitize(input.draftRole)
  if (!draft) return 'clean'
  if (current === 'admin') return 'clean'
  return draft === current ? 'clean' : 'pending'
}
